import React, { useContext, useEffect, useState } from "react";
import Tablecomp from "../comp/Table";
import { contextData } from "../Context";
import { MdDeleteOutline } from "react-icons/md";
import { MdOutlineEdit } from "react-icons/md";
import axios from "axios";
import "./Blog.scss";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { toast } from "react-toastify";

const Blog = () => {
  const { blogsData, setBlogsData } = useContext(contextData);

  const location = useLocation();
  const navigate = useNavigate();

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const deleteBlog = async (id) => {
    try {
      const confirmDelete = window.confirm(
        "Are you sure you want to delete this user?"
      );
      if (!confirmDelete) return;

      await axios.delete(
        `${process.env.REACT_APP_PORT_BACKEND}blog/deleteblog?bId=${id}`
      );

      setBlogsData((prevData) => prevData.filter((item) => item.id !== id));
      toast.success("blog has been deleted");
      window.location.reload();
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const id = params.get("bid");
    console.log(id);
  }, [location]);

  const editBlog = (id) => {
    navigate(`/addBlog?id=${id}`);
  };

  const columnConfig = [
    {
      title: "Sr no.",
      dataIndex: "srno",
      key: "srno",
      render: (text, record, index) =>
        (pagination.current - 1) * pagination.pageSize + index + 1,
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Blog Image",
      dataIndex: "featuredImage",
      key: "featuredImage",
      render: (_, record) => (
        <div class="image" style={{ width: "200px" }}>
          <img
            src={record?.featuredImage}
            alt=""
            style={{ width: "50%", aspectRatio: 3 / 2.5 }}
          />
        </div>
      ),
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      isSearchable: true,
    },
    {
      title: "description",
      dataIndex: "description",
      key: "description",
      render: (_, record) => (
        <div className="action_btn" style={{ display: "flex", gap: "10px" }}>
          <textarea disabled style={{ width: "100%" }}>
            {record.description}
          </textarea>
        </div>
      ),
    },
    {
      title: "action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <div className="action_btn" style={{ display: "flex", gap: "10px" }}>
          <button className="table_btn" onClick={() => deleteBlog(record.bid)}>
            <MdDeleteOutline />
          </button>
          <button className="table_btn" onClick={() => editBlog(record.bid)}>
            <MdOutlineEdit />
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      <div class="top_section">
        <div class="btn_list">
          <Link to="/addBlog" class="btn">
            Add Blog
          </Link>
        </div>
      </div>
      <Tablecomp
        columnConfig={columnConfig}
        tableData={blogsData && blogsData}
        pagination={{
          ...pagination,
          onChange: (page, pageSize) => {
            setPagination({ current: page, pageSize });
          },
        }}
      />
    </>
  );
};

export default Blog;
